__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "amg-provider-client";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations-angular-17", "17.3.12", () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(47172))))));
			register("@angular/cdk-angular-17", "17.3.10", () => (__webpack_require__.e(160).then(() => (() => (__webpack_require__(31398))))));
			register("@angular/common-angular-17", "17.3.12", () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))));
			register("@angular/common/http-angular-17", "17.3.12", () => (__webpack_require__.e(824).then(() => (() => (__webpack_require__(46443))))));
			register("@angular/core-angular-17", "17.3.12", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(37580))))));
			register("@angular/core/primitives/signals-angular-17", "17.3.12", () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(85689))))));
			register("@angular/core/rxjs-interop-angular-17", "17.3.12", () => (__webpack_require__.e(693).then(() => (() => (__webpack_require__(49074))))));
			register("@angular/forms-angular-17", "17.3.12", () => (__webpack_require__.e(75).then(() => (() => (__webpack_require__(34456))))));
			register("@angular/platform-browser-angular-17", "17.3.12", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(80436))))));
			register("@angular/router-angular-17", "17.3.12", () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(95072))))));
			register("@aw/cancel-reason-lib-angular-17", "4.3.1", () => (__webpack_require__.e(321).then(() => (() => (__webpack_require__(702))))));
			register("@elastic/apm-rum-angular-17", "5.17.4", () => (__webpack_require__.e(530).then(() => (() => (__webpack_require__(36530))))));
			register("rxjs-angular-17", "7.8.2", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(31340))))));
			register("rxjs/operators-angular-17", "7.8.2", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(23620))))));
			register("rxjs/webSocket-angular-17", "7.8.2", () => (__webpack_require__.e(749).then(() => (() => (__webpack_require__(86749))))));
			register("tslib-angular-17", "2.8.1", () => (__webpack_require__.e(398).then(() => (() => (__webpack_require__(24398))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};